import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLoyaltyUserCard } from '../../services/api';

export const fetchLoyaltyAssignments = createAsyncThunk(
    'loyaltyAssign/fetchAssignments',
    async ({ perPage, page, filters }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyUserCard(perPage, page, [], filters);
            const data = response.data;
            return {
                cards: data.data || data,
                totalPages: data.last_page,
                userTypes: response.UserType,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

const loyaltyAssignSlice = createSlice({
    name: 'loyaltyAssign',
    initialState: {
        cards: [],
        userTypes: [],
        loading: true,
        error: '',
        totalPages: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoyaltyAssignments.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLoyaltyAssignments.fulfilled, (state, action) => {
                state.cards = action.payload.cards;
                state.totalPages = action.payload.totalPages;
                state.userTypes = action.payload.userTypes;
                state.loading = false;
            })
            .addCase(fetchLoyaltyAssignments.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            });
    },
});

export default loyaltyAssignSlice.reducer;
